import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventNoteIcon from "@mui/icons-material/EventNote";
import HealingIcon from '@mui/icons-material/Healing';
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ClinicLogo from "../../../Assests/cosmos  Logo.png";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ReportIcon from '@mui/icons-material/Report';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';

export default function AppointmentDetailsSidebar() {
  const [state, setState] = React.useState({ left: false, top: false });
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const location = useLocation();

  // Extract params from the URL manually
  const pathSegments = location.pathname.split("/");
  const uuid = pathSegments[4]; // 4th index after splitting `/provider/patient/PatientDetails/uuid/pid`
  const pid = pathSegments[5];
  const eid = pathSegments[6];
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };


  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        // background: "linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)",
        background:"#000d0ea8",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
      }}
      role="presentation"
      onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}
      onKeyDown={isLargeScreen ? null : toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
        <img src={ClinicLogo} alt="Hospital Logo" style={{ maxWidth: "100%", maxHeight: 65 }} />
      </Box>
      <Divider />
      <List sx={{ flexGrow: 1 }}>
        {[
          { text: `${eid}`, icon: <HealingIcon />, path: `/provider/appointment/appot-data/${uuid}/${pid}/${eid}` },
          { text: "Profile", icon: <DashboardIcon />, path: `/provider/appointment/PatientDetails/${uuid}/${pid}/${eid}` },
          { text: "Allergies", icon: <AcUnitIcon />, path: `/provider/appointment/allergies/${uuid}/${pid}/${eid}` },
          { text: "Lab Reports", icon: <ReportIcon />, path: `/provider/appointment/lab-reports/${uuid}/${pid}/${eid}` },
          { text: "Documents", icon: <FileCopyIcon />, path: `/provider/appointment/documents/${uuid}/${pid}/${eid}` },
          { text: "Appointments", icon: <EventNoteIcon />, path: `/provider/appointment/appointments/${uuid}/${pid}/${eid}` },
          { text: "Exercises", icon: <SportsGymnasticsIcon />, path: `/provider/appointment/exercises/${uuid}/${pid}` },
          
          
        ].map((item) => (
          <ListItem
            key={item.text}
            disablePadding
            sx={{
              backgroundColor: location.pathname === item.path ? "rgb(255 255 255 / 62%)" : "inherit",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
              width: "100%",
            }}
          >
            <Link to={item.path} style={{ textDecoration: "none", color: "white", width: "100%" }}>
              <ListItemButton onClick={isLargeScreen ? null : toggleDrawer(anchor, false)}>
                <ListItemIcon style={{ color: "white" }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {isLargeScreen ? (
        <Drawer
          variant="permanent"
          anchor="left"
          open
          sx={{
            "& .MuiDrawer-paper": {
              width: 250,
              boxSizing: "border-box",
              // background: "linear-gradient(135deg, #ffcbc9 0%, #fea5b8 30%, #e990c6 60%, #c196c1 100%)",
              borderTopRightRadius: 30,
              borderBottomRightRadius: 30,
              overflowX: "hidden",
            },
          }}
        >
          {list("left")}
        </Drawer>
      ) : (
        <SwipeableDrawer
          anchor="top"
          open={state.top}
          onClose={toggleDrawer("top", false)}
          onOpen={toggleDrawer("top", true)}
          sx={{
            "& .MuiDrawer-paper": {
              borderBottomLeftRadius: 30,
              borderBottomRightRadius: 30,
              background: "linear-gradient(135deg, #ffcbc9 0%, #fea5b8 30%, #e990c6 60%, #c196c1 100%)",
              overflowX: "hidden",
            },
          }}
        >
          {list("top")}
        </SwipeableDrawer>
      )}


    </div>
  );
}
